import { useSetAtom } from "jotai";
import { type ChangeEvent, useState } from "react";
import { widgetMenuOptionsAtom } from "@/interface/AppStore";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { applyValue, setNewOptions } from "../../lib";
import { RangeInput } from "../RangeInput/RangeInput";

interface BorderWidthInputProps {
    initialWidth?: number;
    options: widgetOption[];
}
export function BorderWidthInput({ initialWidth, options }: BorderWidthInputProps) {
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const [width, setWidth] = useState(initialWidth ?? 1);

    const handleRangeChange = (event: ChangeEvent<HTMLInputElement>) => {
        const rangeValue = Number(event.currentTarget.value);

        setWidth(rangeValue);

        const setNewBorderOptions = setNewOptions({ name: "border", setWidgetMenuOptions });

        applyValue({
            options,
            value: { borderWidth: rangeValue },
            setNewOptions: setNewBorderOptions,
        });
    };

    return (
        <RangeInput
            min={1}
            max={30}
            step={1}
            value={width}
            name="lineWidth"
            onChange={handleRangeChange}
        />
    );
}
